import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions, } from 'chart.js';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from "./NSChartColumn.module.css"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export interface NSChartColumnProps extends IBaseComponentProps
{
	labels: string[];
	datasets: number[];
	range: {
		min: number,
		max: number,
	}
	yGrid?: boolean;
	height?: number;
	width?: number;
}

export function NSChartColumn(props: NSChartColumnProps)
{
	const data = {
		labels: props.labels,
		datasets: [
			{
				label: 'Dataset 1',
				data: props.datasets,
				backgroundColor: '#3354F4',
				borderRadius: 10,
				barThickness: 12,
				borderSkipped: false,
			},
		],
	};

	const options: ChartOptions<'bar'> = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: true,
				callbacks: {
					label: function (context)
					{
						return `$${context.raw}`;
					},
				},
			},
		},
		scales: {
			x: {
				ticks: {
					font: {
						size: 8,
						weight: 700
					},
					color: '#141B5C',
					maxRotation: 554,
					minRotation: 0,
				},
				grid: {
					display: false,
				},
				border: {
					display: false,
				}
			},
			y: {
				min: props.range.min,
				max: props.range.max,
				ticks: {
					callback: function (value)
					{
						return `$${value}`;
					},
					font: {
						size: 8,
						weight: 700,
					},
					color: '#141B5C',
				},
				grid: {
					display: props.yGrid,
					color: "#E6EEF5"
				},
				border: {
					display: false,
				},
			},
		},
	};

	return (
		<div style={props.style} className={`${Styles.chart_column_container} ${props.classList?.join(" ") ?? ""}`}>
			<Bar
				data={data}
				options={options}
				height={props.height ? props.height : 250}
				width={props.width ? props.width : 320}
			/>
		</div>
	);
};